import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import row from '../row';
import Icon from '../icon';

var _createNamespace = createNamespace('search-bar'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('SearchBar'),
    data: function data() {
        return {
            stopLoop: false,
            timeoutHandler: undefined,
            placeholderIndex: 0
        };
    },
    props: {
        placeholder: {
            type: [String, Array],
            default: ''
        },
        loopSpeed: {
            type: [String, Number],
            default: 2000
        },
        buttonText: {
            type: String,
            default: '搜索'
        },
        value: {
            type: String,
            default: ''
        },
        buttonMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isPlaceholderArray: function isPlaceholderArray() {
            return Array.isArray(this.placeholder);
        },
        placeholderArray: function placeholderArray() {
            return this.isPlaceholderArray ? this.placeholder : [this.placeholder];
        },
        submitValue: function submitValue() {
            return this.isPlaceholderArray ? this.value || this.placeholderArray[this.placeholderIndex] : this.value;
        }
    },
    watch: {
        placeholder: function placeholder() {
            this.changePlaceholder();
        }
    },
    render: function render() {
        var h = arguments[0];
        return h(
            'mai-row',
            {
                class: b({
                    'button-mode': this.buttonMode
                }),
                on: {
                    click: this.handleBarClick
                }
            },
            [
                h(
                    'mai-row',
                    {
                        attrs: {
                            align: 'center',
                            justify: 'center'
                        },
                        class: [b('input-wrapper'), 'mai-flex-1']
                    },
                    [
                        h('mai-icon', {
                            class: b('icon'),
                            attrs: {
                                color: '#bdbdbd',
                                name: 'search',
                                size: '32'
                            }
                        }),
                        h('input', {
                            class: [b('input'), 'mai-flex-1'],
                            on: {
                                blur: this.handleBlur,
                                focus: this.handleFocus,
                                input: this.handleInput,
                                keyup: this.handleKeyup
                            },
                            attrs: {
                                placeholder: this.placeholderArray[this.placeholderIndex]
                            },
                            domProps: {
                                value: this.value
                            }
                        })
                    ]
                ),
                this.$slots.button ||
                    h(
                        'button',
                        {
                            class: b('button'),
                            attrs: {
                                color: '#ffca11'
                            },
                            on: {
                                click: this.handleClick
                            }
                        },
                        [this.buttonText]
                    )
            ]
        );
    },
    methods: {
        handleInput: function handleInput(e) {
            this.stopLoop = e.target.value.length > 0;
            this.emitWrapper('input', e.target.value);
        },
        handleBlur: function handleBlur() {
            if (!this.stopLoop) {
                this.changePlaceholder();
            }
        },
        handleFocus: function handleFocus(e) {
            if (this.buttonMode) {
                e.stopPropagation();
                e.preventDefault();
                e.target.blur();
            }
        },
        handleKeyup: function handleKeyup(e) {
            if (e.keyCode === 13) {
                this.emitWrapper('submit', this.submitValue);
            }
        },
        handleClick: function handleClick() {
            this.emitWrapper('submit', this.submitValue);
        },
        handleBarClick: function handleBarClick() {
            if (this.buttonMode) {
                this.$emit('click');
            }
        },
        emitWrapper: function emitWrapper() {
            if (this.buttonMode) {
                return;
            }

            this.$emit.apply(this, arguments);
        },
        changePlaceholder: function changePlaceholder() {
            var _this = this;

            var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : parseInt(this.loopSpeed);

            var handler = function handler() {
                if (_this.timeoutHandler) {
                    clearTimeout(_this.timeoutHandler);
                    _this.timeoutHandler = undefined;
                }

                if (_this.stopLoop) {
                    return;
                }

                var next = _this.placeholderIndex + 1;

                if (next <= _this.placeholderArray.length - 1) {
                    _this.placeholderIndex = next;
                } else {
                    _this.placeholderIndex = 0;
                }

                _this.timeoutHandler = setTimeout(handler, timeout);
            };

            if (Array.isArray(this.placeholder)) {
                handler();
            }
        }
    },
    created: function created() {
        this.changePlaceholder();
    },
    components: {
        MaiRow: row,
        MaiIcon: Icon
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
